module.exports = __webpack_public_path__ + "static/media/scu_logo.36a08d17.svg";